<script setup>
import {reactive, onMounted, onUnmounted, ref, nextTick} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";
import {useDisplay} from "vuetify";

const compName = 'TimeExpenseComponent';

const form = ref(null);

const props = defineProps({
  contextSchemaA: String,
  contextIdA: String
});

const { width } = useDisplay()

const data = reactive({
  dataLoading: true,
  headers: [
    {
      title: 'Category',
      align: 'left',
      key: 'description',
      sortable: false
    },
    { title: 'Amount', key: 'amount', sortable: false },
    { title: 'Quantity', key: 'quantity', sortable: false },
    { title: 'Total', key: 'total', sortable: false },
    { title: 'Person', key: 'name', sortable: false },
    { title: 'Comment', key: 'comment', sortable: false },
    { title: 'Actions', key: 'actions', sortable: false },
  ],
  headersInvoiced: [
    {
      title: 'Category',
      align: 'left',
      key: 'description',
    },
    { title: 'Amount', key: 'amount' },
    { title: 'Quantity', key: 'quantity' },
    { title: 'Total', key: 'total' },
    { title: 'Person', key: 'name' },
    { title: 'Comment', key: 'comment' },
    { title: 'Invoice ID', key: 'id' },
  ],
  invoiceDateForm: false,
  // invoiceDateModel: new Date().toLocaleDateString('en-US'),
  invoiceDateModel: '',
  invoiced: [],
  isDisabledAddExpense: false,
  isDisabledGenerateInvoice: false,
  loading: false,
  menu: false,
  pendingTotal: null,
  newItem: {
    amount: null,
    quantity: null,
    description: 'Flat Rate Fee',
    name: null,
    comment: null
  },
  newII: false,
  pending: [],
  pendingTask: null,
  people: [],
  generating: false,
  showButtons: false,
  defaultItem: {
    amount: null,
    comment: null,
    description: null,
    invoiceitemid: null,
    name: null,
    personid: null,
    quantity: null,
    total: null,
  },
  editedItem: {
    amount: null,
    comment: null,
    description: null,
    invoiceitemid: null,
    name: null,
    personid: null,
    quantity: null,
    total: null,
  },
  valid: true,
});

const closeClaim = () => {
  data.loading = true;
  ApiWrapper.post('time-expense', 'close-claim', {
        claimId: props.contextIdA
      })
      .then((response) => {
        data.loading = false
        activeComponentStore.notifyComponents(['claims'],compName);
        ToastUtil.successMsg('Closed claim');
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.loading = false;
      })
}

const deleteItem = (item) => {
  let deleteMessage = confirm(
      'Are you sure you want to delete this item?'
  )
  if (deleteMessage === true) {
    data.loading = true
    ApiWrapper.post('time-expense', 'delete', {
          item: item,
          id: props.contextIdA
        })
        .then((response) => {
          getData()
          activeComponentStore.notifyComponents(['disbursementrules','disbursements'],compName);
          ToastUtil.successMsg('Deleted expense');
        })
        .catch((err) => {
          ToastUtil.error(err);
          data.loading = false;
        })
  }
}

const discardEdit = (item) => {
  item.isediting = false
  nextTick(() => {
    data.editedItem = Object.assign({}, data.defaultItem)
    data.editedIndex = -1
  })
}

// discardEdit(item) {
//   item.description = data.tempItem.description
//   item.amount = data.tempItem.amount
//   item.quantity = data.tempItem.quantity
//   item.name = data.tempItem.name
//   item.comment = data.tempItem.comment
//   item.personid = data.tempItem.personid
//   item.isediting = false
// },

const discardItem = () => {
  data.newItem.amount = null
  data.newItem.quantity = null
  data.newItem.description = 'Flat Rate Fee'
  data.newItem.name = null
  data.newItem.comment = null
  data.newItem.personid = null
  data.newII = false
}

const formatDate = (date) => {
  if (!date) return null
  const [year, month, day] = date.split('-')
  return `${month}/${day}/${year}`
}

const getData = () => {
  data.loading = true
  ApiWrapper.post('time-expense', 'time-expense', {
        claimId: props.contextIdA
      })
      .then((response) => {
        data.invoiced = response.invoiced
        data.pending = response.pending;
        let pendingTotal = 0
        for(let x = 0; x < data.pending.length; x++) {
          pendingTotal += Number(data.pending[x].amount) * Number(data.pending[x].quantity)
        }
        data.pendingTotal = Number(pendingTotal).toFixed(2);
        data.pendingTask = response.pendingTask
        data.people = response.people
        data.people.push({name:'Nobody'});
        data.categories = response.categories.map(function (obj) {
          return obj.category
        })
        if(!data.categories.includes('Misc.')) {
          data.categories.push('Misc.')
        }
        if(!data.categories.includes('Admin Fee')) {
          data.categories.push('Admin Fee')
        }
        data.categories.sort()
        data.isDisabledAddExpense = false
        data.isDisabledGenerateInvoice = false
        data.generating = false
      })
      .catch((err) => {
        ToastUtil.error(err);
      })
      .finally(()=>{
        data.loading = false
        data.dataLoading = false
      })
}

// isEditing(item) {
//   data.editedItem.amount = item.amount
//   data.editedItem.description = item.description
//   data.editedItem.quantity = item.quantity
//   data.editedItem.name = item.name
//   data.editedItem.comment = item.comment
//   data.editedItem.personid = item.personid
//   item.isediting = true
// },

const editItem = (item) => {
  item.isediting = true
  data.editedIndex = data.pending.indexOf(item)
  data.editedItem = Object.assign({}, item)
  for(let x in data.people){
    if(data.people[x].name === item.name){
      data.editedItem.name = data.people[x].id
    }
  }
}

const saveEdit = (item) => {
  item.isediting = false
  data.loading = true
  ApiWrapper.post('time-expense', 'edit', {
        editedItem: data.editedItem
      })
      .then((response) => {
        getData()
        activeComponentStore.notifyComponents(['disbursementrules','disbursements'],compName);
        ToastUtil.successMsg('Updated expense');
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.loading = false;
      })
}

const saveItem = () => {
  if (form.value.validate()) {
    data.newII = false
    data.isDisabledAddExpense = true
    data.loading = true
    ApiWrapper.post('time-expense', 'create', {
          newInvoiceItem: data.newItem,
          claimId: props.contextIdA
        })
        .then((response) => {
          getData()
          discardItem()
          activeComponentStore.notifyComponents(['disbursementrules','disbursements'],compName);
          ToastUtil.successMsg('Created expense');
        })
        .catch((err) => {
          ToastUtil.error(err);
          data.isDisabledAddExpense = false;
          data.loading = false;
        })
  }
}

onMounted(()=>{
  activeComponentStore.registerComponent(
      compName,
      [
        'tasks',
        'disbursements',
        'person'
      ],
      getData
  );
  getData()
});

onUnmounted(() => {
  activeComponentStore.deregisterComponent(compName);
});

</script>

<template>
  <v-container fluid>
    <v-card>
      <v-toolbar density="compact" flat color="white">
        <v-toolbar-title>Time and Expense</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        ></v-progress-linear>

        <v-divider class="mx-4" inset vertical></v-divider>

        <v-spacer></v-spacer>

        <v-btn
            size="small"
            variant="elevated"
            v-if="!data.newII && Permissions.checkPermissions(['time-expenses.create'])"
            color="primary"
            dark
            class="px-2"
            @click="data.newII = true"
        >New Invoice Item</v-btn
        >
      </v-toolbar>

      <v-form
          ref="form"
          v-model="data.valid"
          lazy-validation
          v-if="data.newII"
      >
        <v-select
            class="mx-2"
            v-model="data.newItem.description"
            label="Category"
            :items="data.categories"
            :rules="[v => !!v || 'Category is required']"
        ></v-select>

        <v-text-field
            class="mx-2"
            type="text"
            v-model="data.newItem.comment"
            label="Comment"
        ></v-text-field>

        <v-text-field
            class="mx-2"
            type="number"
            v-model="data.newItem.amount"
            label="Amount"
            :rules="[v => !!v || 'Amount is required']"
            prefix="$"
        ></v-text-field>

        <v-text-field
            class="mx-2"
            type="number"
            v-model="data.newItem.quantity"
            label="Quantity"
            :rules="[v => !!v || 'Quantity is required']"
        ></v-text-field>

        <v-select
            class="mx-2"
            v-model="data.newItem.name"
            label="People"
            :items="data.people"
            item-title="name"
            :rules="[v => !!v || 'People is required']"
        ></v-select>

        <v-card-actions>
          <v-btn
              size="small"
              variant="elevated"
              @click="saveItem"
              color="primary"
              :disabled="!data.valid || data.isDisabledAddExpense"
          >
            <v-icon size="small" class="mr-1" color="white"
            >mdi-plus</v-icon
            >
            Add Expense
          </v-btn>
          <v-btn size="small" variant="elevated" @click="discardItem" color="error">
            <v-icon size="small" class="mr-1" color="white">mdi-close</v-icon>
            Cancel
          </v-btn>
        </v-card-actions>
      </v-form>

      <v-toolbar density="compact" flat color="white">
        <v-toolbar-title>Pending</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <span> Total Amount Pending: ${{data.pendingTotal}}</span>
      </v-toolbar>

      <v-data-table
          density="compact"
          :headers="data.headers"
          :items="data.pending"
          item-value="id"
          hide-default-footer
          disable-pagination
          class="elevation-1"
          loading-text="Loading... Please wait"
          :items-per-page="-1"
          :mobile="width <= 1700"
      >
        <template v-slot:[`item.description`]="{ item }">
          <v-select
              class="mx-2"
              v-if="item.isediting"
              v-model="data.editedItem.description"
              label="Category"
              :items="data.categories"
              :rules="[v => !!v || 'Category is required']"
          ></v-select>
          <div v-else>{{item.description}}</div>
        </template>
        <template v-slot:[`item.comment`]="{ item }">
          <v-text-field
              v-if="item.isediting"
              v-model="data.editedItem.comment"
          ></v-text-field>
          <div v-else>{{item.comment}}</div>
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          <v-text-field
              type="number"
              v-if="item.isediting"
              v-model="data.editedItem.amount"
              prefix="$"
          ></v-text-field>
          <div v-else>{{`$${Number(item.amount).toFixed(2)}`}}</div>
        </template>
        <template v-slot:[`item.quantity`]="{ item }">
          <v-text-field
              type="number"
              v-if="item.isediting"
              v-model="data.editedItem.quantity"
          ></v-text-field>
          <div v-else>{{item.quantity}}</div>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <div>{{`$${Number(item.total).toFixed(2)}`}}</div>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <v-select
              class="mx-2"
              v-if="item.isediting"
              v-model="data.editedItem.name"
              label="People"
              :items="data.people"
              item-title="name"
              item-value="id"
              :rules="[v => !!v || 'People is required']"
          ></v-select>
          <div v-else>{{item.name}}</div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div v-if="item.isediting">
            <v-btn
                size="small"
                variant="elevated"
                class="pa-1"
                @click="saveEdit(item)"
                color="primary"
            >
              <v-icon color="white">mdi-plus</v-icon>
            </v-btn>
            <v-btn
                size="small"
                variant="elevated"
                class="pa-1"
                @click="discardEdit(item)"
                color="error"
            >
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </div>
          <div v-else>
            <v-icon v-if="Permissions.checkPermissions(['time-expenses.update'])" @click="editItem(item)"> mdi-pencil </v-icon>
            <v-icon v-if="Permissions.checkPermissions(['time-expenses.delete'])" @click="deleteItem(item)"> mdi-delete </v-icon>
          </div>
        </template>
      </v-data-table>
      <v-divider></v-divider>
      <v-toolbar density="compact" flat color="white">
        <v-toolbar-title>Invoiced</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>

      <v-data-table
          density="compact"
          :headers="data.headersInvoiced"
          :items="data.invoiced"
          hide-default-footer
          disable-pagination
          class="elevation-1"
          :loading="data.dataLoading"
          loading-text="Loading... Please wait"
          :items-per-page="-1"
          :mobile="width <= 1700"
      >
        <template v-slot:[`item.amount`]="{ item }">
          <div>{{`$${Number(item.amount).toFixed(2)}`}}</div>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <div>{{`$${Number(item.total).toFixed(2)}`}}</div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
  .container {
    padding: 5px;
  }
  [v-cloak] {
    display: none;
  }
  #input-10 {
    font-size: 13px !important;
  }
</style>